import {Component, OnInit} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {MessageService, PrimeNGConfig} from 'primeng/api';
import {AppMessageService, MessageItem} from './shared/core/message/app-message.service';
import {NavigationCancel, Router} from '@angular/router';
import {LoaderService} from './shared/core/loader/loader.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

    constructor(private router: Router,
                private messageService: MessageService,
                private appMessageService: AppMessageService,
                private loaderService: LoaderService,
                private primeNGConfig: PrimeNGConfig,
                private translateService: TranslateService) {
    }

    ngOnInit(): void {
        this.appMessageService.getMsgEmitter().subscribe(item => this.addMsgItem(item));
        this.translateService.get('primeng').subscribe(props => this.primeNGConfig.setTranslation(props));

        this.router.events.subscribe(event => {
            if (event instanceof NavigationCancel) {
                this.loaderService.hide();
                this.appMessageService.addMsgDanger('Você não possui permissão para acessar essa página!');
                console.log('Você não possui permissão para acessar essa página!', event);

                // this.router.navigateByUrl('/')
                //     .then(value => console.log(value));
            }
        });
    }

    /**
     * Adiciona o item de mensagem a visualização.
     */
    private addMsgItem(messageItem: MessageItem): void {
        this.messageService.add({
            severity: messageItem.type,
            detail: messageItem.msg,
            closable: false,
            // sticky: true
            life: 10000
        });
    }
}
